import React from "react";

export function SectionHeader({ eyebrow, title, subtitle, action, className = "" }) {
  return (
    <div className={`flex flex-wrap items-end justify-between gap-4 mb-8 ${className}`}>
      <div>
        {eyebrow && <div className="eyebrow mb-2">{eyebrow}</div>}
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-serif font-bold text-stone-900 tracking-tight">
          {title}
        </h2>
        {subtitle && <p className="mt-2 text-stone-600 max-w-2xl">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}
